// extracted by mini-css-extract-plugin
export var backdropBlur = "_n0-0";
export var contentCard = "_n0-5";
export var frame = "_n0-2";
export var image = "_n0-4";
export var imagePane = "_n0-3";
export var modal = "_n0-1";